var _g, _circle, _path, _path2, _path3, _path4, _g2, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 280,
    viewBox: "0 0 283 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_895_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.772 121.673C155.766 120.171 155.043 118.464 154.68 116.627L155.416 116.481C155.25 115.645 155.164 114.78 155.164 113.895V111.573H154.414V106.93H155.164V102.287H154.414V97.6445H155.164V93.0017H154.414V88.3588H155.164V83.716H154.414V79.0731H155.164V74.4302H154.414V69.7874H155.164V65.1445H154.414V60.5017H155.164V55.8588H154.414V51.216H155.164V48.8945C155.164 48.0087 155.25 47.1438 155.416 46.3078L154.68 46.1623C155.043 44.3255 155.766 42.618 156.772 41.1159L157.395 41.5332C158.362 40.0879 159.607 38.8434 161.052 37.8758L160.635 37.2526C162.137 36.247 163.845 35.5244 165.681 35.161L165.827 35.8967C166.663 35.7314 167.528 35.6445 168.414 35.6445H170.997V34.8945H176.164V35.6445H181.33V34.8945H186.497V35.6445H191.664V34.8945H196.83V35.6445H199.414C200.299 35.6445 201.164 35.7314 202 35.8967L202.146 35.161C203.983 35.5244 205.69 36.247 207.192 37.2526L206.775 37.8758C208.22 38.8434 209.465 40.0879 210.432 41.5332L211.055 41.1159C212.061 42.618 212.784 44.3255 213.147 46.1623L212.411 46.3078C212.577 47.1438 212.664 48.0087 212.664 48.8945V51.216H213.414V55.8588H212.664V60.5017H213.414V65.1445H212.664V69.7874H213.414V74.4302H212.664V79.0731H213.414V83.716H212.664V88.3588H213.414V93.0017H212.664V97.6445H213.414V102.287H212.664V106.93H213.414V111.573H212.664V113.895C212.664 114.78 212.577 115.645 212.411 116.481L213.147 116.627C212.784 118.464 212.061 120.171 211.055 121.673L210.432 121.256C209.465 122.701 208.22 123.946 206.775 124.913L207.192 125.536C205.69 126.542 203.983 127.265 202.146 127.628L202 126.892C201.164 127.058 200.299 127.145 199.414 127.145H196.83V127.895H191.664V127.145H186.497V127.895H181.33V127.145H176.164V127.895H170.997V127.145H168.414C167.528 127.145 166.663 127.058 165.827 126.892L165.681 127.628C163.845 127.265 162.137 126.542 160.635 125.536L161.052 124.913C159.607 123.946 158.362 122.701 157.395 121.256L156.772 121.673Z",
    stroke: "#DDE8ED",
    strokeWidth: 1.5,
    strokeDasharray: "5 5",
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212.914,
    cy: 121.395,
    r: 18.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.705 114.948V122.603H220.36C220.01 126.135 217.029 128.895 213.404 128.895C209.543 128.895 206.414 125.765 206.414 121.904C206.414 118.279 209.173 115.298 212.705 114.948ZM214.103 113.895C217.985 114.228 221.079 117.323 221.414 121.205H214.103V113.895Z",
    fill: "#C1CBCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.103 113.895C217.985 114.228 221.079 117.323 221.413 121.205H214.103V113.895Z",
    fill: "#4288F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.414 34.8945C242.414 30.4763 245.995 26.8945 250.414 26.8945H274.414C278.832 26.8945 282.414 30.4763 282.414 34.8945V52.8945C282.414 57.3128 278.832 60.8945 274.414 60.8945H250.414C245.995 60.8945 242.414 57.3128 242.414 52.8945V34.8945Z",
    fill: "#DFE9ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4136 25.8945C94.4136 20.3717 98.8907 15.8945 104.414 15.8945H175.414C180.936 15.8945 185.414 20.3717 185.414 25.8945V87.8945C185.414 93.4174 180.936 97.8945 175.414 97.8945H104.414C98.8907 97.8945 94.4136 93.4174 94.4136 87.8945V25.8945Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_895_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4136 25.8945C94.4136 20.3717 98.8907 15.8945 104.414 15.8945H175.414C180.936 15.8945 185.414 20.3717 185.414 25.8945V34.8945H94.4136V25.8945Z",
    fill: "#DEE8ED"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.914,
    cy: 25.3945,
    r: 2.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.914,
    cy: 25.3945,
    r: 2.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.914,
    cy: 25.3945,
    r: 2.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.414,
    y: 47.8945,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#E9F3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.414,
    y: 48.8945,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#62D294"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123.414,
    y: 56.8945,
    width: 26,
    height: 4,
    rx: 2,
    fill: "#E9F3F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.414,
    y: 69.8945,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#E9F3F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.414,
    y: 70.8945,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#62D294"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 123.414,
    y: 78.8945,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#E9F3F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1586 271.869L28.5776 272.011L29.062 256.81L21.643 256.668L21.1586 271.869Z",
    fill: "#F5C1A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4042 271.387L20.4027 271.219C20.2544 271.214 20.1103 271.254 19.9957 271.332C19.8812 271.41 19.8035 271.521 19.7763 271.645L18.3646 277.273C18.3348 277.393 18.3332 277.517 18.3598 277.639C18.3865 277.761 18.4409 277.878 18.5198 277.983C18.5988 278.088 18.7009 278.18 18.8201 278.252C18.9392 278.324 19.0732 278.376 19.2143 278.404L19.4543 278.408C22.3644 278.419 24.4534 278.304 28.1341 278.372C30.3944 278.415 37.1373 278.746 40.2979 278.805C43.4584 278.864 43.7859 276.236 42.5136 275.972C36.7935 274.793 32.4899 273.212 30.6477 271.796C30.3039 271.531 29.8596 271.385 29.4042 271.387Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7084 257.565L29.1232 257.707L28.8681 265.504L21.4533 265.362L21.7084 257.565Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1469 273.044L60.5928 273.853L61.7321 259.266L54.296 258.458L53.1469 273.044Z",
    fill: "#F5C1A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2943 271.796L52.4005 271.693C52.254 271.692 52.113 271.734 52.0006 271.813C51.8882 271.891 51.811 272.001 51.7817 272.124L50.4318 277.777C50.3983 277.895 50.3926 278.019 50.4151 278.141C50.4376 278.263 50.4878 278.381 50.5629 278.487C50.6379 278.593 50.7363 278.686 50.8522 278.761C50.9682 278.835 51.0994 278.889 51.2383 278.92L51.477 278.923C54.3712 278.913 56.4476 278.783 60.1185 278.825C62.3569 278.851 69.0756 279.127 72.2093 279.163C75.343 279.2 75.6535 276.566 74.3857 276.311C68.6859 275.18 64.3907 273.619 62.5452 272.214C62.1985 271.947 61.7525 271.798 61.2943 271.796Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3253 258.449L61.8612 259.253L61.2977 266.018L53.7176 265.928L54.3253 258.449Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9681 156.464L59.6914 157.621C62.6963 172.698 72.7538 217.288 64.9154 264.249L53.3222 264.113C53.3222 264.113 54.6728 212.758 44.9057 189.248C43.588 201.601 42.0029 214.737 40.7546 221.715C37.599 238.884 31.0554 263.462 31.0554 263.462L19.776 263.33C19.776 263.33 22.0928 239.958 23.4096 223.027C24.8484 204.626 25.9192 160.247 25.9681 156.464Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1191 189.076C46.8124 193.206 48.0861 197.433 48.9269 201.713C50.074 190.709 46.247 178.807 46.247 178.807L45.1191 189.076Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.098 109.923C58.098 109.923 70.0372 131.103 76.6998 132.12C83.6448 133.339 97.0999 109.135 97.0999 109.135L104.028 105.165C104.884 104.674 105.203 103.615 104.773 102.69L102.35 97.4659L103.971 93.1026C104.137 92.6563 104.175 92.1676 104.079 91.6886C103.931 90.9412 102.977 90.657 102.497 91.2198C100.312 93.7795 95.7314 99.2129 93.5201 102.32C93.0326 102.765 93.0648 104.688 92.6578 105.06C92.3093 105.852 78.1306 122.092 77.399 121.797C76.6674 121.502 70.3375 107.142 70.3375 107.142L58.098 109.923Z",
    fill: "#F5C1A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.157 113.502L53.7242 115.185L59.9746 120.602L64.1787 125.044C65.0983 126.015 66.6554 125.937 67.3451 124.884L73.5531 115.408C73.9219 114.845 73.9536 114.117 73.6368 113.485L68.0353 102.317C68.0353 102.317 65.9134 97.8948 60.9134 96.8948L52.157 113.502Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.838 117.438L61.1348 125.332C62.9568 118.99 60.1259 111.233 60.1259 111.233L53.838 117.438Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4741 97.4516C56.5699 94.8137 54.0182 94.1291 49.8419 93.0575C45.9135 92.3948 43.1627 91.8844 38.9135 92.3948C31.8422 93.2436 28.4686 94.3339 24.0355 96.7778C21.4968 99.859 21.7951 109.352 21.6024 121.71C26.6497 135.511 25.1532 158.583 25.1532 158.583C37.5602 162.14 48.458 162.476 60.6989 158.33C60.6989 158.33 59.1783 133.354 62.045 122.383C65.302 110.151 66.4406 101.201 62.4741 97.4516Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9135 92.3948C41.4592 96.8997 44.4134 96.8949 46.4134 96.8949C48.4134 96.8949 49.8576 95.4954 50.344 95.0542C50.344 95.0542 50.1321 92.6037 49.7598 90.7986C49.5636 89.6848 49.6208 88.5529 49.9277 87.4731C50.0674 86.8677 50.2458 86.2712 50.4621 85.6865L40.8257 76.9468C41.5159 81.8371 40.9135 86.8948 38.9135 92.3948Z",
    fill: "#F5C1A2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2686 80.7873C40.2342 86.3646 46.4766 89.6553 49.9463 91.4977C49.9238 90.1485 48.9184 88.7869 51.3754 88.8178L42.2686 80.7873Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7885 65.0505C59.7885 65.0505 62.6671 74.0172 57.937 78.0433C53.207 82.0695 50.6528 65.1104 50.6528 65.1104L59.7885 65.0505Z",
    fill: "#6F493C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6769 86.4981C45.0093 87.8909 46.6324 89.2223 48.5917 89.6158C50.5511 90.0094 52.5788 89.8073 54.3637 89.0406C56.4897 88.1273 58.5196 86.3262 59.4508 84.1405C59.5838 83.8502 60.1998 82.1726 60.1772 80.8227C60.1139 77.0369 60.9201 66.4358 56.0016 66.3739C53.0354 65.4368 43.1265 64.1922 40.8801 68.6748C40.2379 69.9502 39.9393 71.3554 40.0087 72.7755C40.2111 79.4217 40.1439 82.9391 43.6769 86.4981Z",
    fill: "#F5C1A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6878 62.8356L45.1328 65.7461C44.6002 65.9723 44.1867 66.3778 43.9754 66.8808C43.764 67.3838 43.7705 67.9472 43.9936 68.4576C45.0511 70.9075 43.6065 74.6799 41.5948 76.1647C41.5948 76.1647 41.469 75.1086 40.5153 75.3416C39.5616 75.5746 38.5007 77.6297 40.4355 80.2766C40.4355 80.2766 38.0688 81.084 36.3465 75.2794C34.7262 69.9187 34.5004 66.4594 34.978 63.7967L44.6878 62.8356Z",
    fill: "#6F493C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7326 69.4169C39.2995 69.474 42.8373 69.0106 46.2138 68.0437C55.9552 65.4843 60.5988 68.542 60.5988 68.542C61.2199 67.9199 61.6788 67.1747 61.9425 66.3603C62.2062 65.5459 62.268 64.6826 62.1235 63.8327C61.5223 61.2113 57.4839 61.0597 57.4839 61.0597C57.4839 61.0597 55.9328 58.1685 53.185 57.4617C50.4373 56.755 48.0559 59.211 48.0559 59.211C48.0559 59.211 44.4138 56.5205 40.6766 57.6428C39.4139 57.9826 38.3292 58.7141 37.6039 59.7149C36.8786 60.7157 36.5566 61.9251 36.6918 63.1408C36.6918 63.1408 32.2421 63.8929 32.5947 66.0179C32.9473 68.1429 35.7326 69.4169 35.7326 69.4169Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.486 78.1362C37.2376 79.674 38.6161 80.8948 40.3202 81.5316C42.5819 82.3525 43.9121 80.5878 43.4487 78.5294C43.0316 76.694 41.3571 74.0092 38.9645 74.0767C38.4546 74.0985 37.9625 74.2365 37.5327 74.4781C37.1028 74.7197 36.7488 75.0573 36.5027 75.4604C36.2566 75.8635 36.1262 76.3193 36.1233 76.7865C36.1204 77.2537 36.2451 77.7176 36.486 78.1362Z",
    fill: "#F5C1A2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5869 124.652L31.6005 110.779C31.6005 110.779 23.2723 110.735 21.7223 114.989C20.9783 117.03 21.0465 121.032 21.0465 121.032L22.5869 124.652Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9983 122.85L62.9933 124.205L63.9134 115.395C63.9134 115.395 62.718 120.45 61.9983 122.85Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7872 167.314L3.24488 171.078C1.05906 171.388 -0.358232 173.397 0.0792826 175.566L3.59143 192.976C4.02895 195.145 6.15559 196.652 8.34141 196.342L34.8838 192.577C37.0696 192.267 38.4869 190.258 38.0494 188.089L34.5372 170.679C34.0997 168.511 31.9731 167.004 29.7872 167.314Z",
    fill: "#4288F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20496 112.739C9.20496 112.739 3.05826 122.966 1.95193 126.58C0.845596 130.193 9.16236 164.187 9.16236 164.187C9.16236 164.187 8.34634 164.75 8.56298 165.472C8.77962 166.195 12.23 175.409 12.5424 175.791C12.8549 176.173 22.0991 178.233 22.8278 176.881C23.3846 175.848 22.0834 169.263 21.4383 166.213C21.2332 165.243 20.5341 164.412 19.586 163.989L15.711 162.257C15.711 162.257 10.4219 134.591 10.9135 130.895C12.5424 126.58 22.6865 115.363 22.6865 115.363L9.20496 112.739Z",
    fill: "#F5C1A2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8811 93.8123C38.5226 103.768 32.5073 110.336 28.4347 114.502C24.5252 118.385 23.282 120.21 19.4181 123.243C18.6595 123.839 17.5421 123.745 16.8084 123.048L8.78845 115.421C8.0691 114.737 7.92415 113.669 8.45293 112.889C10.4727 109.908 15.4522 102.706 19.1347 98.5952C22.3266 94.8679 27.8484 95.0722 32.8811 93.8123Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_895_358",
    x: 134.414,
    y: 19.8945,
    width: 99,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0 0.133333 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_895_358",
    x: 74.4136,
    y: 0.894531,
    width: 131,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0 0.133333 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_358",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ed442d1b3ebe68bf99d0afe987453da6.svg";
export { ForwardRef as ReactComponent };